// src/context/EncomendasContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { db, paths } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { getNormalizedDateString } from '../utils/helpers';

const EncomendasContext = createContext();

export const useEncomendasAuth = () => useContext(EncomendasContext);

export const EncomendasAuthProvider = ({ children }) => {
    const { userProfile } = useAuth();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuthorization = async () => {
            setIsLoading(true);
            if (!userProfile || !userProfile.cpf) {
                setIsAuthorized(false);
                setIsLoading(false);
                return;
            }
            
            // 1. Admin está SEMPRE autorizado a ver o link (para gerenciar)
            if (userProfile.nivel === 'admin') {
                 setIsAuthorized(true);
                 setIsLoading(false);
                 return;
            }

            // 2. Outros usuários (Cmt/Aux) precisam estar na escala
            const userCPF = userProfile.cpf;
            try {
                // Obter data de HOJE (ex: 2025-11-12)
                const todayStr = getNormalizedDateString(new Date());
                
                // Obter data de ONTEM (ex: 2025-11-11)
                const yesterday = new Date(Date.now() - 86400000); // 24h em milissegundos
                const yesterdayStr = getNormalizedDateString(yesterday);
                
                const todayRef = doc(db, paths.escalasEncomendas, todayStr);
                const yesterdayRef = doc(db, paths.escalasEncomendas, yesterdayStr);
                
                const [todaySnap, yesterdaySnap] = await Promise.all([getDoc(todayRef), getDoc(yesterdayRef)]);
                
                let authorized = false;
                if (todaySnap.exists()) {
                    const data = todaySnap.data();
                    if (data.cpf_cg === userCPF || data.cpf_aux_cg === userCPF) authorized = true;
                }
                if (!authorized && yesterdaySnap.exists()) {
                    const data = yesterdaySnap.data();
                    if (data.cpf_cg === userCPF || data.cpf_aux_cg === userCPF) authorized = true;
                }
                
                setIsAuthorized(authorized);

            } catch (err) {
                console.error("Erro (EncomendasAuth):", err);
                setIsAuthorized(false);
            } finally {
                setIsLoading(false);
            }
        };
        
        checkAuthorization();
    }, [userProfile]); // Recalcula sempre que o usuário mudar

    return (
        <EncomendasContext.Provider value={{ isAuthorized, isLoading }}>
            {children}
        </EncomendasContext.Provider>
    );
};